import React, { ReactNode } from 'react';

import { UseQueryResult } from '@tanstack/react-query';

import classNames from 'classnames';

import { Spinner } from '@uikit';

import { getErrorMessage } from '@utilities/errors/getErrorMessage';

interface QueryStateProps {
  isEmpty: boolean;
  query: UseQueryResult;
  loading?: ReactNode;
  className?: string;
  content?: ReactNode;
}

const QueryState = ({ query, content, isEmpty, loading, className }: QueryStateProps) => {
  const { isError, isLoading, error, refetch } = query;

  const showLoader = !isError && isLoading;
  const showEmpty = !isLoading && !isError && isEmpty;
  const showError = !isLoading && isError;

  if (!showLoader && !showEmpty && !showError) {
    return content;
  }

  return (
    <div className={classNames('flex flex-col flex-1', className)}>
      {showLoader && (loading || <Spinner className="m-auto" />)}

      {showEmpty && <p className="m-auto text-center text-[#9A9AAC]">Empty</p>}

      {showError && (
        <div className="flex flex-col gap-3 m-auto">
          <p className="text-center text-secondary-600">
            Error happened while loading:
            <br />
            {getErrorMessage(error)}
          </p>
          <button
            className="msq-btn msq-btn-md msq-btn-primary mx-auto"
            onClick={() => {
              refetch();
            }}
          >
            Try Again
          </button>
        </div>
      )}
    </div>
  );
};

export default QueryState;
